/**
 * ReferralQuickShareModal.jsx — Modal "Invite friends" rapide.
 * §12sexies — Croix cerclée obligatoire. §12quinquies — border-radius 1rem cards, 0.625rem boutons.
 * §20 — Zéro littéral couleur. §64 — English only. §65 — earnicoins (jamais EIC). §89 — pas de tiret cadratin.
 * §10 — partage la primitive ReferralInviteBlock avec la section Settings (template parent unique).
 *
 * Usage :
 *   <ReferralQuickShareModal open={open} onClose={() => setOpen(false)} referralLink={link} />
 */
import React from 'react';
import {
  ModalHeader, ModalHeaderTitle, ModalCloseBtn, ModalBody,
} from './ModalDA';
import { ModalShell } from './ModalShell';
import styled from 'styled-components';
import { COLORS, FONTS } from './theme';
import ReferralInviteBlock from './ReferralInviteBlock';

/* ─── Styled ────────────────────────────────────────────────────────────────── */

const Description = styled.p`
  font-family: ${FONTS.body};
  font-size: 0.9375rem;
  color: ${COLORS.ink};
  line-height: 1.55;
  margin: 0 0 1.25rem;
`;

const Highlight = styled.strong`
  color: ${COLORS.accent};
`;

/* ─── Component ─────────────────────────────────────────────────────────────── */

/**
 * @param {object}   props
 * @param {boolean}  props.open         - Whether the modal is visible
 * @param {function} props.onClose      - Called when the modal should close
 * @param {string}   [props.referralLink] - Referral URL to display
 */
export default function ReferralQuickShareModal({ open, onClose, referralLink = '' }) {
  if (!open) return null;

  return (
    <ModalShell isOpen={open} onClose={onClose} $width="26rem" aria-label="Invite friends">
      <ModalHeader>
        <ModalHeaderTitle>Invite friends &amp; earn earnicoins</ModalHeaderTitle>
        <ModalCloseBtn onClick={onClose} aria-label="Close">✕</ModalCloseBtn>
      </ModalHeader>

      <ModalBody>
        <Description>
          Invite friends to <Highlight>Earniverse</Highlight>, the AAA VR metaverse, and its
          collectibles marketplace <Highlight>Earnimarket</Highlight>. You both earn <Highlight>50 earnicoins</Highlight> when
          they join, and <Highlight>up to 100 earnicoins bonus each</Highlight> when they link their Epic Games account!
        </Description>

        <ReferralInviteBlock referralLink={referralLink} />
      </ModalBody>
    </ModalShell>
  );
}
